<div class="flex flex-col gap-4">

    <p-card class="mb-4">
        <ng-template pTemplate="header">
            <div class="flex justify-between items-center w-full">
                <h2 class="text-xl font-semibold m-0">Remove Old Recruiting Calls</h2>
            </div>
        </ng-template>
        <div class="p-1">
            <form [formGroup]="dateForm" (ngSubmit)="onConfirmDate()">
                <div class="grid grid-cols-1 md:grid-cols-2 items-center">
                    <label for="cutOffDate" class="font-semibold">Remove all activities before this date:</label>
                    <div class="flex flex-col items-end w-full">
                        <p-datepicker id="cutOffDate" [maxDate]="maxDate" formControlName="cutOffDate"
                            dateFormat="yy-mm-dd" [placeholder]="placeholderDate"
                            class="w-full md:w-2/3"></p-datepicker>
                        <p class="mt-2 text-gray-500">
                            Date cannot be within 90 days of current date
                        </p>
                    </div>
                </div>
                <div class="flex justify-end mt-4">
                    <p-button label="Confirm Date" type="submit" styleClass="btn btn-primary" [disabled]="dateForm.invalid"></p-button>
                </div>
            </form>
        </div>
    </p-card>

    @if (isLoading()) {
    <app-table-skeleton [rowCount]="10" [columnCount]="callsColumns().length"></app-table-skeleton>
    } @else if (oldCalls().length > 0) {
    <p-table [value]="oldCalls()" [columns]="callsColumns()" styleClass="p-datatable-gridlines"
        [tableStyle]="{'min-width': '40rem'}" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20]">

        <ng-template pTemplate="caption">
            <div class="flex justify-between items-center">
                <h3 class="text-lg font-semibold m-0">Confirm Removal</h3>
                <span class="text-sm text-gray-500">Remove <b>{{ oldCalls().length }}</b> scheduled activities on or
                    before <strong>{{ dateForm.value.cutOffDate }}</strong>?</span>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                @for (col of callsColumns(); track col.header) {
                <app-table-header [column]="col"></app-table-header>
                }
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-call>
            <tr>
                @for (col of callsColumns(); track col.header) {
                <app-table-column [column]="col" [data]="call"></app-table-column>
                }
            </tr>
        </ng-template>
    </p-table>
    <div class="flex justify-end items-center mt-4">
            <p-button label="Approve Removal" styleClass="btn btn-primary" (onClick)="onApproveRemoval()" [disabled]="isApproving()"></p-button>
        </div>
        <p class="text-sm text-gray-500 mt-2 text-right">This cannot be undone...</p>
    } @else if (hasSearched() && oldCalls().length === 0) {
        <div class="flex justify-center items-center">
            <p class="text-gray-500 text-center">No old calls to remove.</p>
        </div>
    }
</div>